import React from 'react';
import styles from './MarqueeBanner.module.scss'; // SCSS 모듈 임포트

const MarqueeBanner = () => {
  return (
    <div className={styles.bannerContainer}>
      <div className={styles.marqueeContent}>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
        <span className={styles.marqueeText}>
        SAFE, COMFORTABLE, AND HAPPY: YOUR PET DESERVES THE BEST!
        </span>
      </div>
    </div>
  );
};

export default MarqueeBanner;
